// Public metadata already includes the product title; do not append another brand.
export function pageTitle(title: string, hostname: string): string {
  if (hostname.startsWith("magazine.")) return title || "Hairbook Magazine";
  if (hostname.startsWith("salonjobs.") && title) return title;
  return title ? `${title} | Hairbook Pages` : "Hairbook Pages";
}
